






















































import { cloneDeep, isEmpty } from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import BotLabels from './components/Labels/BotLabels.vue'
import BotProperties from './components/Properties/BotProperties.vue'
import { BotProperty, TabsExtraButtons } from './components/Properties/types'
import PropertiesTabsExtra from './components/PropertiesTabsExtra.vue'

enum Pages {
  Properties,
  Labels,
}

@Component({
  data() {
    return {
      Pages,
    }
  },
  components: {
    BotProperties,
    BotLabels,
    PropertiesTabsExtra,
  }
})
export default class BotPropertiesView extends Vue {
  @Prop() properties!: Array<BotProperty>

  @Prop() labels!: { [key: number]: string }

  @Prop() createLabel!: (name: string) => Promise<{ name: string, id: number }>

  @Prop() deleteLabelFn!: (index: number) => Promise<Array<Record<number, string>>>

  @Prop() renameLabelFn!: (index: number, title: string) => Promise<Array<Record<number, string>> | void>

  @Prop() createProperty!: (path: string, name: string, parent?: number, data?: Record<string, any> | null) => Promise<Array<BotProperty> | void>

  @Prop() renameProperty!: (id: number, name: string) => Promise<Array<BotProperty>>

  @Prop() removeProperty!: (id: number) => Promise<Array<BotProperty>>

  @Prop() exportToCsv!: (target: string, items: Array<any>) => void

  activePage = Pages.Properties

  get buttonsToShow() {
    if (this.activePage === Pages.Properties) {
      return [ TabsExtraButtons.Csv ]
    } else {
      return undefined
    }
  }

  get exportDisabled(): boolean {
    if (this.activePage === Pages.Properties) {
      return isEmpty(this.properties)
    }

    return isEmpty(this.labels)
  }

  exportToCSVHandler(): void {
    const target = this.activePage === Pages.Properties ? 'properties' : 'labels'

    const properties = cloneDeep(this.properties).map((p) => {
      let dataItem: { [key: string]: string | Array<string> } = {}

      Object.entries(p).forEach(([ field, value ]) => {
        if (field !== 'options' && field !== 'id') {
          dataItem[this.$t(`properties_csv_${ field }_table`).toString()] = String(value)
        }
      })

      dataItem.options = p.options ?? '-'

      return dataItem
    })

    const labels = Object.values(this.labels).map((label) => {
      return {
        [this.$t('labels_csv_name_table').toString()]: label,
      }
    })

    if (this.activePage === Pages.Properties) {
      this.exportToCsv(target, properties)
    } else {
      this.exportToCsv(target, labels)
    }
  }
}
